<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>GREEN CAMPUS</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Green Campus Policy</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img class="cover-background w-100 h-100" src="assets/img/hostel/arni2.jpg"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">Green Campus Policy</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">Green Campus Policy – Cultivating Sustainability For A Brighter
                    Future </h2>
                <p>At ARNI University, we are deeply committed to creating a sustainable and eco-friendly environment
                    for both the students and the wider community. Our Green Campus Policy is an initiative is an
                    initiative that brings together responsible resource use, environmental stewardship, and the
                    education of future leaders on the importance of protecting the planet.
                </p>
                <p>By developing sustainable solutions for the environmental, social, and economic requirements of
                    humanity, the Green Campus concept offers educational institutions the chance to rethink their
                    eco-friendly culture and establish new paradigms.
                </p>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <h2 class="h1 mb-1-6 text-primary">Objectives of the Go Green Program:</h2>
                <table class="table table-bordered table-responsive">
                    <tbody>
                    <tr>
                        <td>1. Principal of the Pharmacy and Paramedical Studies</td>
                        <td>Prof. Neeraj Bhandari - Chairman</td>
                    </tr>
                    <tr>
                        <td>2. IQAC Director</td>
                        <td>Dr. Raja Mannar – Secretary</td>
                    </tr>
                    <tr>
                        <td>3. Faculty Representative</td>
                        <td>Dr. Sunita – Nominated</td>
                    </tr>
                    <tr>
                        <td>4. Student Representative</td>
                        <td>Mr. Karan Dhingra – General Secretary</td>
                    </tr>
                    <tr>
                        <td>5. Non-Teaching Staff Representative</td>
                        <td>Mr. Sohan Lal- Office Superintendent</td>
                    </tr>
                    <tr>
                        <td>6. Parent Representative</td>
                        <td>Mr. Naresh Malpotra</td>
                    </tr>
                    <tr>
                        <td>7. Industry Representative</td>
                        <td>Dr. Subhasis Das, Director, Ardent Steel</td>
                    </tr>
                    <tr>
                        <td>8. Alumni Association</td>
                        <td>Mr. Trilochan Singh</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <h2 class="h1 mb-1-6 text-primary">B.Role of the Go- Green Campus Programme:</h2>
                <p>The inspiration for a successful Green Campus must begin at the top and emanate throughout the rest
                    of the campus. Without a strong message of commitment and involvement from both the Chairperson and
                    Members of the Committee, well-intentioned initiatives may be too fragmented to allow for Institute-
                    wide participation. Thus given this, the committee will plan and execute to:</p>
                <ul>
                    <li>Seek views of all the Stakeholders to make the Go Green Campus initiative functional throughout
                        the year.
                    </li>
                    <li>Conduct the Campus' environmental impacts to identify the targets for improvements.</li>
                    <li>Establish a Green Campus Environmental Ethics Awareness campaign.</li>
                    <li>Set forth a Green Campus Mission and a Statement of Principles.</li>
                    <li>Link Green-Campus activities to Academics in the Institute.</li>
                    <li>Organize Awareness Programs for the students, faculty, and society.</li>
                    <li>Chart out a yearly planner for the Institute, local community, and Stakeholders.</li>
                    <li>Develop a strategic plan and create student teams to carry out specific tasks of the strategic
                        plan. For instance, a plan to save energy at the institute level with a time-bound plan to
                        install a Solar Power Station mandatorily either at the top of the Institute building or in an
                        open field. This will enable the institute to have a 24x7 power supply.
                    </li>
                    <li>Phase-out the CFL and conventional light sources such as bulbs and tube lights, halogen and
                        mercury street/campus lights, and get them replaced by LEDs.
                    </li>
                    <li>Conduct an Annual Green, Environment, and Energy Audit.</li>
                    <li>Purchase only Energy Efficient Computers viz: “ENERGY STAR” or any other equivalent.</li>
                    <li>Establish public/private partnerships with personnel from federal, state, and local
                        environmental agencies, utilities, and the business community.
                    </li>
                    <li>Evaluate daily operations in terms of pollution prevention, waste stream management, and energy
                        efficiency reducing, reusing, recycling, and repairing wherever possible.
                    </li>
                    <li>
                        Secure a commitment upfront from the people in charge that well-founded recommendations will be
                        acted upon once audits are completed.
                    </li>
                </ul>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <h2 class="h1 mb-1-6 text-primary">C. Promotion of “Save Energy Tips” in and outside the Institute:</h2>
                <ul>
                    <li>Activate power management features on your computer and monitor so that it will go into a low
                        power “sleep” mode when you are not working on it.
                    </li>
                    <li>Turn off your monitor when you leave your Table.</li>
                    <li>Activate power management features on your laser printer.</li>
                    <li>Whenever possible, shut down rather than log off.</li>
                    <li>Turn off unnecessary lights and use daylight instead.</li>
                    <li>Avoid the use of decorative lighting.</li>
                    <li>Use LED or compact fluorescent bulbs.</li>
                    <li>Keep lights off in conference rooms, classrooms, and lecture halls when they are not in use.
                    </li>
                    <li>Use the fans only when they are needed.</li>
                    <li>Unplug appliances not plugged into power strips (like TVs, Refrigerators, ACs, tea/coffeepots,
                        printers, faxes, chargers etc.).
                    </li>
                </ul>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <h2 class="h1 mb-1-6 text-primary">D. Waste water Management/ Rainwater harvesting:</h2>
                <p>The Institute has to work in the direction of wastewater management, particularly in student hostels.
                    Water flow restrictors on bathroom faucets and showers, low water flow toilets, and automated urinal
                    flushers should be used to cut down campus water use. The Institute will take all necessary measures
                    to implement wastewater management /rainwater harvesting.</p>
                <h3 class=" mb-1-6 text-primary">Major Green Campus Initiatives:</h3>
                <ul>
                    <li>ISO Certification 9001:2008</li>
                    <li>Installation of Solar Power Station</li>
                    <li>Wastewater Management/ Rainwater harvesting.</li>
                    <li>Development of Sewage Water Treatment Plant.</li>
                    <li>Use of Micro-scale techniques.</li>
                    <li>Sensor-based energy conservation.</li>
                    <li>Displayed poster on E-waste Management.</li>
                    <li>Maintenance of water bodies and distribution systems on the campus</li>
                    <li>MIS to make paperless administration.</li>
                    <li>Plastic-free Campus</li>
                    <li>Tree Plantation Drive</li>
                    <li>Cleanliness Drive</li>
                    <li>Landscaping and gardens</li>
                    <li>Use of LEDs only</li>
                    <li>Digital Library/ E-Learning Centre</li>
                    <li>Organization of sensitization programs for the stakeholders</li>
                    <li>Establishment of Enviro-Club</li>
                    <li>Green, Environment, and Energy Audit conducted</li>
                    <li>Restricted entry of automobiles</li>
                    <li>No Vehicle Day observed</li>
                    <li>he Institute will make all the necessary efforts to involve the students, faculty, and staff in
                        “Green Campus Initiatives” by designating the volunteers of Enviro Club, NSS & NCC cadets,
                        printing T-shirts/ Caps with the green campus initiative slogan specially designed for the
                        purpose.
                    </li>
                </ul>
                <h5 class=" mb-1-6 text-primary">For further details and inquiries, please feel free to write to us:
                    vc@arni.in</h5>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>
